<template>
  <div class="newAgency">
    <div class="newAgency-title">
      <el-row class="agency-title">
        <el-col :span="12">
          <p class="text">
            私募基金管理机构-
            <span style="color: #008fff"> {{ title }}申请 </span>
          </p>
        </el-col>
      </el-row>
      <el-row class="steps-row">
        <el-steps :active="activeStep" align-center>
          <el-step
            :title="item"
            description
            v-for="(item, index) of stepArr"
            :key="item"
            @click.native="toStep(index)"
          ></el-step>
        </el-steps>
      </el-row>
    </div>

    <step-com
      :myactiveStep="activeStep"
      @active="activeChange"
      :comArr="comArr"
      :title="title"
      :updateTitle="updateTitle"
    ></step-com>
  </div>
</template>

<script>
import StepCom from "common/components/steps/stepItem";
const path = `FundManagement/components/newCom`;

const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

export default {
  components: {
    StepCom,
  },

  inject: ["reload"],

  mounted() {
    this.title = flags[this.$route.query.flag];
    if (this.$route.query.flag === "update") {
      this.updateTitle = "新设";
    } else {
      this.updateTitle = flags[this.$route.query.flag];
    }
  },

  data() {
    return {
      stepArr: ["基本信息", "出资人信息", "人员信息", "其他信息", "完成申请"],
      activeStep: 0,
      codeId: "",
      comArr: [
        `${path}/step1`,
        `${path}/step2`,
        `${path}/step3`,
        `${path}/step4`,
        `${path}/step5`,
      ],
      percentage: 80,
      title: "",
      updateTitle: "",
    };
  },
  methods: {
    activeChange(ev) {
      this.activeStep = ev;
    },
    toStep(index) {
      if (index >= this.activeStep) return;
      else {
        this.$confirm(
          "请确定已编辑的内容已经保存,避免已填写数据丢失, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            // this.returnBasic();
            this.activeStep = index;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
  },
  watch: {
    $route(newValue) {
      this.title = flags[newValue.query.flag];

      this.reload();
    },
  },
};
</script>

<style>
.el-step__head.is-process {
  border-color: #f0f1f3 !important;
}
.el-step__line {
  background-color: #f0f1f3 !important;
}
.el-step__title.is-wait {
  color: #d3d7db !important;
}
.el-step__title.is-process {
  color: #3a424c !important;
}

</style>
<style lang="scss" scoped>
.newAgency {
  height: 100%;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  &-title {
    height: 220px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 12px 0px #cccccc80;
    padding: 20px;
    display: flex;
    flex: 0 0 auto;
    // overflow: auto;
    flex-direction: column;
    .steps-row {
      height: 100%;
      padding-bottom: 15px;
      display: flex;
      // overflow: auto;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>


